/* eslint-disable react/jsx-pascal-case */
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { Controller, useForm } from 'react-hook-form';
import { useMutation } from 'react-query';
import VegaHeader from '../../../../components/common/VegaHeader';
import { useSnackbar } from '../../../../providers/SnackbarProvider';
import {
  CardAllotmentOrderDto,
  CardAllotmentStatusEnum,
  UpdateCardAllotmentOrderStatusRequest,
} from '../../../../types/card';
import { CardAllocationService } from '../../../apis';
import CIMS_Modal, {
  IButtonGroupProps,
} from '../../../components/common/CIMS_Modal';
import { useCardOrderRequest } from '../context';
import LosSelect from '../../../../components/common/deprecated/LosSelect';
import { EditFormFiled } from '../../../../components/common/deprecated/EditFormFiled';

type MarkAsShippedModalProps = {
  isOpen: boolean;
  handleClose: () => void;
  cardAllotmentOrder?: CardAllotmentOrderDto;
};

const DELIVERY_PARTNERS = [
  {
    label: 'Delhivery',
    value: 'delhivery',
  },
  {
    label: 'Indiapost',
    value: 'indiapost',
  },
  {
    label: 'Bluedart',
    value: 'bluedart',
  },
  {
    label: 'Ecom express',
    value: 'ecomExpress',
  },
  {
    label: 'Hand Delivered',
    value: 'handDelivered',
  },
];

function MarkAsShippedModal({
  isOpen,
  handleClose,
  cardAllotmentOrder,
}: MarkAsShippedModalProps) {
  const hookForm = useForm<{
    shipment: {
      mailerVendorId: string;
      trackingId: string;
    };
  }>();
  const mailerVendorId = hookForm.watch('shipment.mailerVendorId');

  const { setSnackbar } = useSnackbar();
  const { listAllotmentQuery } = useCardOrderRequest();

  const updateAllocationStatusMutation = useMutation({
    mutationFn: (data: UpdateCardAllotmentOrderStatusRequest) => {
      return CardAllocationService.updateAllocationStatus(data);
    },
    onSuccess: () => {
      listAllotmentQuery?.refetch();
      setSnackbar('Mark as shipped successfully');
    },
    onError: (error) => {
      setSnackbar('Error while updating status (Shipped)', 'error');
    },
  });

  const onSubmit = (data: {
    shipment: {
      mailerVendorId: string;
      trackingId: string;
    };
  }) => {
    if (cardAllotmentOrder) {
      cardAllotmentOrder &&
        updateAllocationStatusMutation.mutate({
          cardAllotmentOrderId: cardAllotmentOrder?.id,
          status: CardAllotmentStatusEnum.DISPATCHED,
          mailerVendorId: data.shipment?.mailerVendorId,
          mailerVendorTrackingId: data.shipment.trackingId,
        });
    }
  };

  const buttons: IButtonGroupProps[] = [
    {
      text: 'Submit',
      disabled: !hookForm.formState.isValid,
      onSubmit: () => {
        onSubmit && onSubmit(hookForm.getValues());
        handleClose();
      },
      icon: '',
      isOutline: false,
    },
  ];
  return (
    <CIMS_Modal
      maxWidth="sm"
      open={isOpen}
      handleClose={handleClose}
      header="Mark as shipped"
      buttonGroup={buttons}
    >
      <Box sx={{ px: 3, pt: 2, pb: 6 }}>
        <Stack spacing={2}>
          <Controller
            name="shipment.mailerVendorId"
            control={hookForm.control}
            rules={{ required: 'Required' }}
            render={({ field }) => (
              <Box>
                <VegaHeader text="Delivery Partner Name" />
                <LosSelect
                  options={DELIVERY_PARTNERS}
                  value={field.value}
                  onChange={(e) => field.onChange(e.target.value)}
                  placeholder="Add Delivery Partner Name"
                />
              </Box>
            )}
          />
          {mailerVendorId !== 'handDelivered' && (
            <Controller
              name="shipment.trackingId"
              control={hookForm.control}
              rules={{ required: 'Required' }}
              render={({ field }) => (
                <EditFormFiled
                  title={'TRACKING ID'}
                  description={field.value}
                  onChange={(val) => {
                    field.onChange(val);
                  }}
                  placeHolder={'Enter Tracking ID'}
                />
              )}
            />
          )}
        </Stack>
      </Box>
    </CIMS_Modal>
  );
}
export default MarkAsShippedModal;
